<template>
    <div>
        <kgr-dropdown
            inline
            display="name"
            :label="$t('institution')"
            :options="filteredInstitutions"
            :value="value"
            :loading="loading"
            :default-text="defaultText"
            @post-input="onInput"
        />
    </div>
</template>

<script>
import Dropdown from './Dropdown.vue';
import Kindergarten from '../../../../js/dto/Kindergarten';
import KindergartenRepository from '../../../../js/repository/KindergartenRepository';
import Section from '../../../../js/dto/Section';

export default {
    components: {
        'kgr-dropdown': Dropdown,
    },
    props: {
        federationId: {
            type: Number,
            required: true,
        },
        value: {
            type: Kindergarten,
            required: false,
            default: null,
        },
        defaultText: {
            type: String,
            required: false,
        },
        section: {
            type: Section,
            required: false,
            default: null,
        },
        province: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            loading: true,
            institutions: [],
        };
    },
    computed: {
        filteredInstitutions() {
            let institutions = this.institutions;

            if (this.section !== null) {
                institutions = institutions.filter((institution) => {
                    return institution.sections.map((section) => section.id).indexOf(this.section.id) !== -1;
                });
            }

            if (this.province !== null) {
                institutions = institutions.filter((institution) => institution.province === this.province);
            }

            return institutions;
        },
    },
    created() {
        KindergartenRepository
            .findAll(this.federationId)
            .then((data) => {
                this.institutions = data;
                this.loading = false;
            })
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
